import React from "react";
import { Typography } from "@mui/material";

interface IBank {
  bank: any;
}

const BankInfo: React.FC<IBank> = ({ bank }): JSX.Element => {
  return (
    <Typography variant="caption" sx={{ mt: 2, mb: 0 }}>
      {bank.name}
      <br />
      {bank.street} {bank.house_number}
      <br />
      {bank.postal_code} {bank.city}
    </Typography>
  );
};

export default BankInfo;
